import { useState } from 'react'
import { MdAdd, MdFlight } from 'react-icons/md'
import { AirportCard } from '../../components/cards'
import { Button, LoadingSpinner, EmptyState, Pagination } from '../../components/ui'
import { useAirport } from '../../hooks/useAirport'

function AirportList({ airports = [], onViewAirport, onEditAirport, onDeleteAirport }) {
  const [isLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(12) // Show 12 airports per page (4 rows of 3 in grid)

  const { deleteAirportAsync } = useAirport()

  const handleDeleteAirport = async (airport) => {
    try {
      await deleteAirportAsync(airport._id)
      if (onDeleteAirport) {
        onDeleteAirport(airport)
      }
    } catch (error) {
      console.error('Error deleting airport:', error)
    }
  }

  const handleViewAirport = (airport) => {
    if (onViewAirport) {
      onViewAirport(airport)
    }
  }

  const handleEditAirport = (airport) => {
    if (onEditAirport) {
      onEditAirport(airport)
    }
  }

  // Pagination logic
  const totalPages = Math.ceil(airports.length / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const paginatedAirports = airports.slice(startIndex, endIndex)

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Airport Grid */}
      {airports.length === 0 ? (
        <EmptyState
          icon={<MdFlight className="text-4xl text-neutral-400" />}
          title="No airports found"
          description="Get started by adding your first airport"
          action={
            <Button
              variant="primary"
              onClick={() => {
                /* TODO: Implement create airport */
              }}
              className="flex items-center space-x-2"
            >
              <MdAdd className="text-lg" />
              <span>Add Airport</span>
            </Button>
          }
        />
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {paginatedAirports.map((airport) => (
              <AirportCard
                key={airport._id}
                airport={airport}
                onView={() => handleViewAirport(airport)}
                onEdit={() => handleEditAirport(airport)}
                onDelete={() => handleDeleteAirport(airport)}
              />
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pt-4 border-t border-neutral-200 dark:border-neutral-700">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                itemsPerPage={itemsPerPage}
                totalItems={airports.length}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default AirportList
